// src/services/fieldSupervisorService.js (UPDATED)
import api from '../config/axios';

const BASE_PATH = '/field-supervisors';

// ============= SUPERVISOR LIST & SEARCH =============

/**
 * Get all active supervisors with assignment counts
 */
export const getAllSupervisors = async () => {
  const response = await api.get(BASE_PATH);
  return response.data;
};

/**
 * Search supervisors by keyword
 */
export const searchSupervisors = async (keyword) => {
  const response = await api.get(`${BASE_PATH}/search`, {
    params: { keyword }
  });
  return response.data;
};

// ============= SUPERVISOR DETAIL =============

/**
 * Get supervisor detail with all assignments
 */
export const getSupervisorDetail = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

// ============= ASSIGNMENT OPERATIONS =============

/**
 * Assign FO Segment or Tower Site to Supervisor with multiple scopes
 * @param {Object} assignmentData
 * @param {number} assignmentData.supervisorId
 * @param {number} assignmentData.targetId
 * @param {string} assignmentData.type - "SEGMENT" or "SITE"
 * @param {Array<string>} assignmentData.scopes - ["SURVEY", "PERMIT", "IMPLEMENTATION"] (1-3 items)
 * @param {string} assignmentData.remarks - Optional remarks
 */
export const assignToSupervisor = async (assignmentData) => {
  const response = await api.post(`${BASE_PATH}/assign`, assignmentData);
  return response.data;
};

/**
 * Unassign by assignment ID (cancels entire assignment)
 */
export const unassignById = async (assignmentId) => {
  const response = await api.delete(`${BASE_PATH}/assignments/${assignmentId}`);
  return response.data;
};

/**
 * Unassign supervisor from specific target
 */
export const unassignSupervisorFromTarget = async (supervisorId, targetType, targetId) => {
  const response = await api.delete(`${BASE_PATH}/unassign`, {
    params: { supervisorId, targetType, targetId }
  });
  return response.data;
};

/**
 * Remove specific scope from assignment
 */
export const removeScopeFromAssignment = async (assignmentId, scope) => {
  const response = await api.delete(`${BASE_PATH}/assignments/${assignmentId}/scopes/${scope}`);
  return response.data;
};

// ============= AVAILABLE SEGMENTS/SITES =============

/**
 * Get available FO Segments for assignment
 * @param {number} supervisorId - REQUIRED: Current supervisor ID
 * @param {Object} filters
 * @param {string} filters.projectType - TOWER, FO, TOWER_COLO
 * @param {string} filters.mainArea - Province name
 * @param {string} filters.search - Free text search
 * @param {number} page
 * @param {number} size
 */
export const getAvailableSegments = async (supervisorId, filters = {}, page = 0, size = 10) => {
  const response = await api.get(`${BASE_PATH}/available-segments`, {
    params: {
      supervisorId, // ✅ REQUIRED
      projectType: filters.projectType || undefined,
      mainArea: filters.mainArea || undefined,
      search: filters.search || undefined,
      page,
      size
    }
  });
  return response.data;
};

/**
 * Get available Tower Sites for assignment
 * @param {number} supervisorId - REQUIRED: Current supervisor ID
 * @param {Object} filters
 * @param {string} filters.projectType - TOWER, FO, TOWER_COLO
 * @param {string} filters.provinsi - Province name
 * @param {string} filters.search - Free text search
 * @param {number} page
 * @param {number} size
 */
export const getAvailableSites = async (supervisorId, filters = {}, page = 0, size = 10) => {
  const response = await api.get(`${BASE_PATH}/available-sites`, {
    params: {
      supervisorId, // ✅ REQUIRED
      projectType: filters.projectType || undefined,
      provinsi: filters.provinsi || undefined,
      search: filters.search || undefined,
      page,
      size
    }
  });
  return response.data;
};

// ============= HEALTH CHECK & DOCS =============

export const healthCheck = async () => {
  const response = await api.get(`${BASE_PATH}/health`);
  return response.data;
};

export const getApiDocs = async () => {
  const response = await api.get(`${BASE_PATH}/docs`);
  return response.data;
};

export default {
  getAllSupervisors,
  searchSupervisors,
  getSupervisorDetail,
  assignToSupervisor,
  unassignById,
  unassignSupervisorFromTarget,
  removeScopeFromAssignment,
  getAvailableSegments,
  getAvailableSites,
  healthCheck,
  getApiDocs
};